import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { getSoftwareBySlug } from "../data/software";
import { HonestiCRMPage } from "./HonestiCRMPage";
import { EasyOnPage } from "./EasyOnPage";
import { WhatsappBulkSenderPage } from "./WhatsappBulkSenderPage";
import { SocialMediaAutomationPage } from "./SocialMediaAutomationPage";
import { WhatsappApiPlatformPage } from "./WhatsappApiPlatformPage";
import { SmsBroadcastPage } from "./SmsBroadcastPage";

const customSoftwarePages: Record<string, React.ComponentType> = {
    "honesti-crm": HonestiCRMPage,
    easyon: EasyOnPage,
    "whatsapp-bulk-sender": WhatsappBulkSenderPage,
    "socialmedia-automation-software": SocialMediaAutomationPage,
    "whatsapp-api-platform": WhatsappApiPlatformPage,
    "sms-call-email-broadcast": SmsBroadcastPage,
};

export const SoftwarePage = () => {
    const { slug } = useParams();
    const item = slug ? getSoftwareBySlug(slug) : undefined;

    if (!item) {
        return <Navigate to="/" replace />;
    }

    const Page = slug ? customSoftwarePages[slug] : undefined;
    if (Page) {
        return <Page />;
    }

    return <Navigate to="/" replace />;
};
